// 越南语（越南）
export default {
  company: {
    deviceList: 'Danh sách thiết bị',
    name: 'Caramel Phim',
    desc: 'Tận hưởng khoảnh khắc tuyệt vời!',
    companyName: 'Tên cửa hàng',
    companyInfo: 'Thông tin thương gia',
    linkMan: 'Người liên hệ',
    contactInfo: 'Thông tin liên hệ',
    cooperationWay: 'Phương thức hợp tác',
    jointOperation: 'Liên doanh',
    selfOperated: 'Tự doanh',
    agent: 'Đại lý',
    businessStatus: 'Trạng thái kinh doanh',
    operating: 'Đang hoạt động',
    stopped: 'Đã ngừng hoạt động',
    hasBackend: 'Có mở backend không',
    backendAccount: 'Tài khoản backend',
    backendPassword: 'Mật khẩu backend',
    deviceCount: 'Số lượng máy',
    orderData: 'Dữ liệu đơn hàng',
    companyRatio: 'Tỷ lệ thương gia (%)',
    operatorRatio: 'Tỷ lệ nhà vận hành (%)',
    companyDesc: 'Mô tả thương gia',
    companyAddress: 'Địa chỉ thương gia',
    openAggregatedPay: 'Có mở thanh toán tổng hợp không',
    thirdPayWay: 'Phương thức thanh toán bên thứ ba',
    merchantId: 'Mã thương gia',
    merchantType: 'Loại thương gia',
    merchantAppid: 'Appid thương gia',
    wechatRedirectUrl: 'Địa chỉ chuyển hướng thanh toán WeChat',
    payNotifyUrl: 'Địa chỉ callback thanh toán',
    refundNotifyUrl: 'Địa chỉ callback hoàn tiền',
    sqbMerchantCode: 'Mã thương gia (Shouqianba)',
    sqbDeveloperKey: 'Key nhà phát triển Shouqianba',
    storeActiveCode: 'Mã kích hoạt cửa hàng',
    frontendCallbackUrl: 'Địa chỉ callback frontend',
    merchantSecret: 'Secret thương gia',
    unit: 'cái',
    merchantLevel: 'Cấp độ thương gia',
    level2Merchant: 'Thương gia cấp 2',
    level3Merchant: 'Thương gia cấp 3',
    aggregatedPayMerchant: 'Thương gia thanh toán tổng hợp',
    backendOpen: 'Mở backend',
    forwardIncomingPrefix: 'Huilaimi nhập_',
    qrCodeGenerateFailed: 'Tạo mã QR thất bại, vui lòng thử lại',
    invalidWebUrl: 'Địa chỉ web nhận được không hợp lệ, vui lòng liên hệ quản trị viên',
    noValidWebUrl: 'Không nhận được địa chỉ web hợp lệ',
    fetchDataFailed: 'Lấy dữ liệu thất bại, vui lòng thử lại',
    browserNotSupportDownload: 'Trình duyệt của bạn không hỗ trợ tải tự động, vui lòng nhấp chuột phải để lưu ảnh',
    downloadImageFailed: 'Tải ảnh thất bại, vui lòng thử lại',
    httpError: 'Lỗi HTTP, mã trạng thái: {status}',
    copyCompanyName: 'Sao chép tên cửa hàng',
    copySuccess: 'Sao chép thành công',
    copyFail: 'Sao chép thất bại'
  },
  income: {
    totalIncome: 'Tổng tiền đơn hàng',
    platformIncome: 'Phần chia nền tảng',
    companyIncome: 'Thu nhập hệ thống thương gia',
    subMerchantIncome: 'Phần thương gia cấp 3 được hưởng',
    parentIncome: 'Phần thương gia cấp 2 giữ lại',
    orderCount: 'Số lượng đơn hàng',
    subMerchantIncomeDetail: 'Chi tiết thu nhập thương gia cấp 3',
    subRatioText: 'Giữ lại cấp 3',
    subJustRatioText: 'Hoa hồng cấp 2',
    splitRatio: 'Tỷ lệ chia',
    deviceCount: 'Số lượng thiết bị',
    deviceCode: 'Mã thiết bị',
    deviceName: 'Tên thiết bị'
  },
  login: {
    username: 'Tên đăng nhập',
    password: 'Mật khẩu',
    login: 'Đăng nhập',
    inputUsername: 'Vui lòng nhập tên đăng nhập',
    inputPassword: 'Vui lòng nhập mật khẩu'
  },
  employee: {
    inputAccount: 'Vui lòng nhập tài khoản',
    inputName: 'Vui lòng nhập tên',
    inputMobile: 'Vui lòng nhập số điện thoại',
    selectRole: 'Vui lòng chọn vai trò',
    allRoles: 'Tất cả vai trò',
    allStatus: 'Tất cả trạng thái',
    collapse: 'Thu gọn',
    expand: 'Mở rộng',
    employeeCount: 'Số lượng nhân viên: ',
    addEmployee: '+ Thêm nhân viên',
    account: 'Tài khoản',
    name: 'Tên',
    gender: 'Giới tính',
    role: 'Vai trò',
    company: 'Doanh nghiệp trực thuộc',
    creator: 'Người thêm',
    createTime: 'Thời gian thêm',
    devicePermission: 'Quyền thiết bị',
    deviceCountUnit: '{count} thiết bị',
    viewAllDevices: 'Xem tất cả thiết bị',
    disableAccount: 'Vô hiệu hóa',
    resetPassword: 'Đặt lại mật khẩu',
    assignDevices: 'Phân bổ thiết bị',
    tip: 'Nhắc nhở',
    deleteConfirm: 'Sau khi xóa tài khoản, tài khoản này sẽ không thể đăng nhập vào hệ thống. Xác nhận xóa?',
    employeeName: 'Tên nhân viên: ',
    usernameLabel: 'Tên đăng nhập: ',
    currentPermission: 'Quyền hiện tại: ',
    assignedDevices: 'Đã phân bổ {count} thiết bị',
    selectDevice: 'Chọn thiết bị: ',
    selectDevicePlaceholder: 'Vui lòng chọn thiết bị',
    deviceHint: 'Không chọn thiết bị nào có nghĩa là nhân viên có thể xem tất cả thiết bị của công ty',
    selectAtLeastOneDevice: 'Vui lòng chọn ít nhất 1 thiết bị',
    assignSuccess: 'Phân bổ thiết bị thành công',
    assignFailed: 'Phân bổ thất bại',
    loadDeviceInfoFailed: 'Tải thông tin thiết bị thất bại',
    loadDeviceListFailed: 'Tải danh sách thiết bị thất bại',
    disableConfirmTitle: 'Bạn có chắc muốn vô hiệu hóa tài khoản nhân viên này?',
    disableConfirmContent: 'Sau khi vô hiệu hóa, nhân viên sẽ không thể đăng nhập',
    disableSuccess: 'Vô hiệu hóa thành công',
    enableConfirmTitle: 'Bạn có chắc muốn kích hoạt tài khoản nhân viên này?',
    enableConfirmContent: 'Sau khi kích hoạt, nhân viên có thể đăng nhập',
    enableSuccess: 'Kích hoạt thành công',
    resetPwdConfirmTitle: 'Bạn có chắc muốn đặt lại mật khẩu nhân viên này?',
    resetPwdConfirmContent: 'Sau khi đặt lại, mật khẩu sẽ trở về mật khẩu mặc định (JTphoto0515)',
    resetPwdSuccess: 'Đặt lại mật khẩu thành công',
    addSuccess: 'Thêm nhân viên thành công',
    updateSuccess: 'Sửa nhân viên thành công',
    addTitle: 'Thêm nhân viên',
    editTitle: 'Sửa nhân viên',
    accountLabel: 'Tài khoản:',
    nameLabel: 'Tên:',
    passwordLabel: 'Mật khẩu:',
    defaultPwdTip: 'Để trống để sử dụng mật khẩu mặc định JTphoto0515',
    defaultPwdPlaceholder: 'Để trống để dùng mật khẩu mặc định',
    emailLabel: 'Email:',
    emailInvalid: 'Vui lòng nhập email hợp lệ',
    maxLength50: 'Độ dài không được vượt quá 50 ký tự',
    mobileLabel: 'Điện thoại:',
    mobileInvalid: 'Vui lòng nhập số điện thoại hợp lệ',
    roleSetting: 'Vai trò:',
    statusSetting: 'Trạng thái:',
    selectStatus: 'Vui lòng chọn trạng thái',
    genderSetting: 'Giới tính:',
    selectGender: 'Vui lòng chọn giới tính',
    deptSetting: 'Phòng ban:',
    remarkLabel: 'Ghi chú:',
    remarkPlaceholder: 'Vui lòng nhập ghi chú',
    submit: 'Gửi',
    save: 'Lưu',
    usernameRequired: 'Tên đăng nhập không được để trống',
    usernameMax20: 'Tên đăng nhập không được vượt quá 20 ký tự',
    usernameMin4: 'Tên đăng nhập không được ít hơn 4 ký tự',
    usernameExists: 'Xin lỗi, tên đăng nhập này đã tồn tại',
    mobileRequired: 'Số điện thoại không được để trống!',
    nameRequired: 'Tên không được để trống!',
    roleRequired: 'Vai trò không được để trống!'
  },
  homepage: {
    totalIP: 'Tổng IP',
    todayfc: 'Doanh thu hôm nay',
    weekQOQ: 'So với tuần',
    dayQOQ: 'So với ngày',
    todayCompanyIncome: 'Thu nhập cửa hàng hôm nay',
    todayPlatformIncome: 'Thu nhập nền tảng hôm nay',
    todayFlow: 'Lưu lượng khách hôm nay',
    todayOrder: 'Đơn hàng hôm nay',
    todayRefundOrder: 'Đơn hoàn tiền hôm nay',
    machineOnlineCount: 'Máy trực tuyến',
    machineOfflineCount: 'Máy ngoại tuyến',
    totalPlatformIncome: 'Tổng thu nhập nền tảng',
    totalOperatorIncome: 'Tổng chia sẻ nhà khai thác',
    totalCompanyIncome: 'Tổng thu nhập cửa hàng',
    totalFlow: 'Tổng lưu lượng khách',
    totalOrder: 'Tổng đơn hàng',
    totalRefundOrder: 'Tổng đơn hoàn tiền',
    usage: 'Sử dụng',
    incomeAmount: 'Số tiền thu nhập',
    flow: 'Lưu lượng khách',
    orderCount: 'Số đơn hàng',
    todayIncome: 'Thu nhập hôm nay',
    lastLoginTime: 'Thời gian đăng nhập cuối',
    canWithdrawalIncome: 'Thu nhập có thể rút',
    goodMorning: 'Chào buổi sáng',
    goodForenoon: 'Chào buổi sáng muộn',
    goodNoon: 'Chào buổi trưa',
    goodAfternoon: 'Chào buổi chiều',
    goodEvening: 'Chào buổi tối',
    welcome1: 'Uống cà phê nghỉ ngơi một chút ☕',
    welcome2: 'Muốn chơi LOL với bạn bè không?',
    welcome3: 'Muốn chơi Honor of Kings với bạn bè không?',
    welcome4: 'Mấy ngày không gặp lại xinh hơn rồi 😍',
    welcome5: 'Hôm nay viết bao nhiêu Bug 🐞?',
    welcome6: 'Hôm nay có chat trong nhóm không?',
    welcome7: 'Hôm nay ăn món gì ngon?',
    welcome8: 'Hôm nay bạn đã cười chưa 😊?',
    welcome9: 'Hôm nay có giúp người khác giải quyết vấn đề không?',
    welcome10: 'Dự định ăn gì?',
    welcome11: 'Cuối tuần có đi xem phim không?',
    dateRange: '{start}~{end}',
    withdraw: 'Rút tiền',
    avatarAlt: 'Ảnh đại diện',
    noDept: 'Không có phòng ban',
    noRole: 'Không có vai trò',
    firstVisit: 'Lần đầu truy cập',
    todayIp: 'IP hôm nay',
    todayVisit: 'Lượt truy cập hôm nay',
    totalVisit: 'Tổng lượt truy cập',
    lowPaperTitle: 'Nhắc giấy ảnh của thiết bị sắp hết',
    lowPaperTip: 'Các thiết bị sau còn ít hơn {count} tờ giấy ảnh, vui lòng bổ sung giấy kịp thời để không ảnh hưởng đến việc sử dụng bình thường!',
    lowPaperDeviceName: 'Tên thiết bị',
    lowPaperDeviceCode: 'Mã thiết bị',
    lowPaperCount: 'Số lượng giấy',
    lowPaperClose: 'Đóng'
  },
  device: {
    companyManage: 'Quản lý cửa hàng',
    deviceManage: 'Quản lý thiết bị',
    totalDevices: 'Tổng số máy',
    all: 'Tất cả',
    online: 'Trực tuyến',
    offline: 'Ngoại tuyến',
    updating: 'Đang cập nhật',
    versionUpdate: 'Cập nhật phiên bản',
    export: 'Xuất',
    batchUpdate: 'Cập nhật hàng loạt',
    unbind: 'Hủy liên kết',
    bind: 'Liên kết',
    companyName: 'Tên cửa hàng',
    deviceCode: 'Mã thiết bị',
    appVersion: 'Phiên bản ứng dụng',
    sn: 'Số sê-ri',
    uiName: 'Tên UI',
    uiGroupName: 'Nhóm UI',
    photoTime: 'Thời gian chụp ảnh',
    intervalTime: 'Khoảng thời gian chụp',
    pagerNum: 'Số lượng giấy',
    goodsNum: 'Số lượng sản phẩm',
    filterNum: 'Số lượng bộ lọc',
    address: 'Địa chỉ máy',
    orderCount: 'Số đơn hàng',
    operation: 'Thao tác',
    command: 'Lệnh đã được gửi thành công',
    reset: 'Đặt lại',
    restartApp: 'Khởi động lại ứng dụng',
    showMenu: 'Hiển thị menu',
    hideMenu: 'Ẩn menu',
    reportLog: 'Báo cáo nhật ký',
    isSupperCoins: 'Hỗ trợ xu',
    unbinded: 'Đã hủy liên kết',
    binded: 'Đã liên kết',
    bindStatus: 'Trạng thái liên kết',
    lastestOnlineTime: 'Thời gian trực tuyến cuối',
    macAddress: 'Địa chỉ MAC',
    resolution: 'Độ phân giải',
    deviceSN: 'SN thiết bị',
    deviceVersion: 'Phiên bản thiết bị',
    deviceKey: 'Khóa thiết bị',
    deviceIMEI: 'IMEI thiết bị',
    activationCode: 'Mã kích hoạt',
    leyaoyaoCode: 'Mã Leyaoyao',
    electronicPhoto: 'Ảnh điện tử',
    scanDownload: 'Quét để tải xuống',
    sendFriend: 'Gửi cho bạn bè',
    templateImage: 'Hình mẫu',
    working: 'Đang làm việc',
    workStatus: 'Trạng thái làm việc',
    thumbnail: 'Hình thu nhỏ',
    remoteCode: 'Mã từ xa',
    belongCategory: 'Danh mục',
    allMerchants: 'Tất cả thương nhân',
    assign: 'Phân công',
    viewOrders: 'Xem đơn hàng',
    selectBindMerchant: 'Vui lòng chọn thương nhân cần liên kết',
    pendingVendorActive: 'Chờ kích hoạt Shouqianba',
    vendorActivationCode: 'Mã kích hoạt Shouqianba',
    vendorActivationCodePlaceholder: 'Vui lòng nhập mã kích hoạt Shouqianba',
    vendorActivationCodeRequired: 'Vui lòng nhập mã kích hoạt Shouqianba',
    merchantName: 'Tên thương nhân',
    selectMerchantName: 'Vui lòng chọn tên thương nhân',
    assignDeviceToSub: 'Phân công thiết bị cho thương nhân cấp dưới',
    deviceLabel: 'Thiết bị: ',
    targetMerchant: 'Thương nhân đích',
    selectSubMerchant: 'Vui lòng chọn thương nhân cấp dưới',
    noSubMerchant: 'Không có thương nhân cấp dưới, vui lòng tạo thương nhân cấp 3 trước',
    selectTargetMerchant: 'Vui lòng chọn thương nhân đích',
    assignSuccess: 'Phân công thiết bị thành công',
    assignFailed: 'Phân công thiết bị thất bại',
    selectDeviceToUpdate: 'Vui lòng chọn thiết bị cần cập nhật! Ít nhất một mục',
    setupSuccess: 'Cài đặt thiết bị thành công',
    updateUI: 'Cập nhật UI',
    updateApp: 'Cập nhật APP',
    updateConfig: 'Cập nhật cấu hình',
    shellExec: 'Thực thi lệnh Shell',
    shellCommand: 'Lệnh Shell',
    shellCommandPlaceholder: 'Nhập lệnh Shell cần thực thi, ví dụ: ls -la /tmp',
    sendShellCommand: 'Gửi lệnh Shell',
    dangerousConfirmTip: 'Các lệnh nguy hiểm cần được xác nhận',
    notifiedUpdateUI: 'Đã thông báo thiết bị cập nhật UI',
    notifiedUpdateApp: 'Đã thông báo thiết bị cập nhật APP',
    notifiedUpdateConfig: 'Đã thông báo thiết bị cập nhật cấu hình',
    inputShellCommand: 'Vui lòng nhập lệnh Shell',
    dangerousWarningTitle: '⚠️ Cảnh báo thao tác nguy hiểm',
    dangerousWarningContent: 'Bạn đang thực thi một lệnh nguy hiểm, có thể gây ra sự cố thiết bị! Tiếp tục?',
    confirmExecute: 'Xác nhận thực thi',
    commandSent: 'Đã gửi lệnh, vui lòng chờ thiết bị thực thi',
    sendFailed: 'Gửi thất bại',
    networkError: 'Lỗi mạng, vui lòng thử lại sau',
    confirmUnbind: 'Sau khi hủy liên kết, thiết bị sẽ bị tách khỏi thương nhân. Bạn có chắc chắn muốn hủy liên kết thiết bị này không?',
    copyCompanyName: 'Sao chép tên cửa hàng',
    copyDeviceCode: 'Sao chép mã thiết bị',
    copyActiveCode: 'Sao chép mã kích hoạt',
    copySuccess: 'Sao chép thành công',
    copyFail: 'Sao chép thất bại'
  },
  setting: {
    navbarColor: 'Màu thanh điều hướng',
    themeColor: 'Màu chủ đề',
    navbarPosition: 'Vị trí thanh điều hướng',
    fixedTopRail: 'Cố định thanh trên',
    fixedSidebar: 'Cố định thanh bên',
    multiTabMode: 'Chế độ nhiều tab',
    languageSwitching: 'Chuyển đổi ngôn ngữ',
    userCenter: 'Trung tâm người dùng',
    updatePassword: 'Cập nhật mật khẩu',
    customSystem: 'Tùy chỉnh hệ thống',
    logout: 'Đăng xuất',
    updateCache: 'Cập nhật bộ nhớ đệm',
    refreshCacheSuccess: 'Cập nhật bộ nhớ đệm thành công',
    refreshCacheFailed: 'Cập nhật bộ nhớ đệm thất bại'
  },
  common: {
    confirm: 'Xác nhận',
    cancel: 'Hủy',
    saveSetting: 'Lưu cài đặt',
    languageChanged: 'Chuyển ngôn ngữ thành công',
    timezoneChanged: 'Chuyển múi giờ thành công',
    search: 'Tìm kiếm',
    pleaseInputContent: 'Vui lòng nhập nội dung',
    export: 'Xuất',
    default: 'Mặc định',
    item: 'Mục',
    view: 'Xem',
    setup: 'Cài đặt',
    status: 'Trạng thái',
    showTotal: 'Hiển thị {start} ~ {end} bản ghi, tổng {total} bản ghi',
    yes: 'Có',
    no: 'Không',
    info: 'Thông tin',
    sequenceNumber: 'STT',
    creationTime: 'Thời gian tạo',
    operation: 'Thao tác',
    defaultSort: 'Số thứ tự',
    type: 'Tích hợp',
    edit: 'Chỉnh sửa',
    delete: 'Xóa',
    deleteSuccess: 'Xóa thành công',
    editSuccess: 'Chỉnh sửa thành công',
    updateSuccess: 'Cập nhật thành công',
    connectionError: 'Kết nối máy chủ bất thường, vui lòng thử lại sau!',
    reset: 'Đặt lại',
    allCategory: 'Tất cả danh mục',
    query: 'Truy vấn',
    add: 'Thêm',
    loadError: 'Lỗi tải',
    isDefault: 'Mặc định',
    setDefault: 'Đặt làm mặc định',
    cancelDefault: 'Hủy mặc định',
    batchEdit: 'Chỉnh sửa hàng loạt',
    back: 'Quay lại',
    uploadImg: 'Tải lên hình ảnh',
    uploadImgSuccess: 'Tải lên hình ảnh thành công',
    uploadImgFailed: 'Tải lên thất bại',
    uploadImgTips1: 'Chỉ cho phép định dạng JPG, JPEG, GIF, PNG',
    uploadImgTips2: 'Tệp vượt quá giới hạn 10M, không cho phép tải lên',
    addSuccess: 'Thêm thành công',
    all: 'Tất cả',
    batchAdd: 'Thêm hàng loạt',
    deleteError: 'Xóa thất bại',
    deleteNoData: 'Vui lòng chọn dữ liệu cần xóa',
    disable: 'Vô hiệu hóa',
    enable: 'Kích hoạt',
    exportError: 'Xuất thất bại!',
    exportExecl: 'Xuất Excel',
    exportSuccess: 'Xuất thành công',
    noData: 'Không có dữ liệu',
    operateError: 'Thao tác thất bại, vui lòng thử lại',
    prompt: 'Mẹo',
    searchError: 'Tìm kiếm thất bại',
    selectDataFirst: 'Vui lòng chọn nhãn dán cần xuất trước!',
    uploadError: 'Tải lên thất bại',
    selectAll: 'Chọn tất cả',
    totalRecords: 'Tổng cộng {total} bản ghi',
    closeLeft: 'Đóng bên trái',
    closeRight: 'Đóng bên phải',
    closeOthers: 'Đóng các tab khác'
  },
  template: {
    merchantManagement: 'Quản lý cửa hàng',
    uiManagement: 'Quản lý UI',
    newConfig: 'Khung mới',
    editFrame: 'Chỉnh sửa khung',
    editConfig: 'Chỉnh sửa cấu hình',
    top: 'Trên',
    bottom: 'Dưới',
    builtIn: 'Tích hợp',
    nonBuiltIn: 'Không tích hợp',
    uiConfigName: 'Tên UI',
    background: 'Nền',
    wechatOfficialAccount: 'Mã QR',
    title: 'Tiêu đề',
    banner: 'Banner',
    creationTime: 'Thời gian tạo',
    indicatorColor: 'Màu chỉ báo',
    type: 'Loại',
    appliedMachines: 'Số máy áp dụng',
    freamName: 'Tên khung ảnh',
    editSuccess: 'Chỉnh sửa UI thành công',
    tip: 'Mẹo',
    deletePrompt: 'Xóa cấu hình UI này sẽ khiến người dùng không thể sử dụng. Bạn có chắc chắn muốn xóa không?',
    matchProduct: 'Khớp sản phẩm',
    selectProduct: 'Vui lòng chọn sản phẩm',
    templateFilePng: 'Tệp mẫu PNG',
    maxFileSize: 'Kích thước tệp tối đa 10M',
    addUploadImage: 'Thêm hình ảnh tải lên',
    previewImage: 'Hình xem trước',
    cuttingImage: 'Ảnh cắt',
    groupPhotoFrame: 'Khung ảnh chụp chung',
    groupPhotoYes: 'Chụp chung',
    groupPhotoNo: 'Không chụp chung',
    groupPhotoLensSetting: 'Cài đặt chi tiết ống kính chụp chung',
    groupPhotoConfigured: 'Đã cấu hình ảnh chụp chung',
    groupPhotoNotSet: 'Chưa cài đặt ảnh chụp chung',
    buttonNormal: 'Nút bình thường',
    buttonPressed: 'Nút nhấn',
    buttonNormalExample: 'Ví dụ nút thường',
    buttonPressedExample: 'Ví dụ nút nhấn',
    reuseTemplateFile: 'Dùng lại tệp mẫu',
    reuseNormalButton: 'Dùng lại nút thường',
    reuseAllTemplateFiles: 'Dùng lại tất cả tệp mẫu',
    addSticker: 'Thêm nhãn dán',
    editSticker: 'Chỉnh sửa nhãn dán',
    StickerIndexNum: 'Số thứ tự',
    onlyImage: 'Chỉ có thể tải lên hình ảnh JPG, JPEG, GIF và PNG',
    selectCategory: 'Vui lòng chọn danh mục',
    selectStatus: 'Vui lòng chọn trạng thái',
    selectType: 'Vui lòng chọn loại',
    stickerCategory: 'Danh mục nhãn dán',
    stickerCode: 'Mã nhãn dán',
    stickerFileSize: 'Kích thước tệp',
    stickerName: 'Tên nhãn dán',
    stickerPreview: 'Hình ảnh nhãn dán',
    stickerStatus: 'Trạng thái',
    stickerType: 'Loại',
    staticSticker: 'Nhãn dán tĩnh',
    gifSticker: 'Ảnh động GIF',
    videoSticker: 'Nhãn dán video',
    frameGroup: 'Nhóm khung'
  },
  sticker: {
    stickerPreview: 'Hình sticker',
    stickerCode: 'Mã sticker',
    stickerCategory: 'Danh mục sticker',
    stickerType: 'Loại',
    stickerSize: 'Kích thước',
    stickerFileSize: 'Kích thước tệp',
    StickerIndexNum: 'Số thứ tự',
    stickerStatus: 'Trạng thái',
    stickerName: 'Tên sticker',
    stickerOperation: 'Thao tác',
    addSticker: 'Thêm sticker',
    stickerImage: 'Hình sticker',
    stickerThumbnail: 'Hình thu nhỏ',
    stickerWidth: 'Chiều rộng (pixel)',
    stickerHeight: 'Chiều cao (pixel)',
    stickerDuration: 'Thời lượng',
    stickerTags: 'Thẻ',
    stickerDescription: 'Mô tả',
    statusTips: 'Vui lòng chọn trạng thái',
    typeTips: 'Vui lòng chọn loại',
    categoryTips: 'Vui lòng chọn danh mục',
    editSticker: 'Chỉnh sửa sticker',
    imgPreview: 'Xem trước hình ảnh',
    codeCheckResultErr: '❌ Mã này đã tồn tại, vui lòng thay đổi',
    codeCheckResultOk: '✅ Mã khả dụng',
    inputCodeTips: 'Không bắt buộc. Thiết bị phân loại sticker theo hậu tố mã (vd: ST2D). Khuyến nghị chữ hoa, chữ số và gạch dưới',
    categoryIcon: 'Biểu tượng danh mục',
    categoryName: 'Tên danh mục',
    categoryCode: 'Mã danh mục',
    categoryIconPlaceholder: 'Vui lòng nhập URL biểu tượng',
    addCategory: 'Thêm danh mục',
    editCategory: 'Chỉnh sửa danh mục',
    groupNewAdd: 'Thêm nhóm mới',
    groupEdit: 'Chỉnh sửa nhóm',
    groupName: 'Tên nhóm',
    groupCode: 'Mã nhóm',
    groupIcon: 'Biểu tượng nhóm',
    hasSticker: 'Số lượng sticker',
    groupCodePlaceholder: 'Vui lòng nhập mã nhóm (tiếng Anh viết hoa)',
    groupNamePlaceholder: 'Vui lòng nhập tên nhóm',
    groupDescriptionPHR: 'Vui lòng nhập mô tả nhóm',
    controllerSticker: 'Quản lý',
    addFailed: 'Thêm thất bại',
    addSuccess: 'Thêm thành công',
    confirmDeleteSticker: 'Bạn có chắc chắn muốn xóa nhãn dán này không?',
    deleteFailed: 'Xóa thất bại',
    deleteSuccess: 'Xóa thành công',
    fileDurationDesc: 'Chỉ dành cho video/GIF, tùy chọn',
    fileDurationTips: 'Chỉ bắt buộc với nhãn dán video/GIF',
    fileSizeDesc: 'Tự động điền sau khi tải lên',
    fileSizeExample: 'VD: 51200',
    heightExample: 'VD: 200',
    widthExample: 'VD: 200',
    selectAtLeastOne: 'Vui lòng chọn ít nhất một nhãn dán',
    selectSticker: 'Chọn nhãn dán',
    stickerCodeDesc: 'Mã định danh toàn cục, khuyến nghị dùng định dạng STICKER_XXX',
    stickerCodeTips: 'Vui lòng nhập mã nhãn dán (duy nhất)',
    stickerImageSize: 'Kích thước khuyến nghị: 200x200 px, hỗ trợ định dạng PNG, JPG',
    stickerSlected: 'Nhãn dán đã chọn',
    thumbnail: 'Hình thu nhỏ',
    uploadStickerImage: 'Vui lòng tải lên hình ảnh nhãn dán',
    inputStickerName: 'Vui lòng nhập tên nhãn dán',
    inputStickerCode: 'Vui lòng nhập mã nhãn dán',
    codeFormatTips: 'Khuyến nghị sử dụng định dạng STICKER_XXX',
    codeExists: 'Mã nhãn dán này đã tồn tại, vui lòng thay đổi',
    codeValidateFailed: 'Xác thực thất bại',
    codeValidateError: 'Xác thực mã thất bại, vui lòng thử lại',
    codeFormatError: 'Định dạng mã không hợp lệ, khuyến nghị sử dụng định dạng STICKER_XXX',
    codeCheckFailedRetry: 'Xác thực thất bại, vui lòng thử lại',
    tagsPlaceholder: 'Phân tách nhiều thẻ bằng dấu phẩy, ví dụ: vui, biểu cảm, mặt cười',
    tagsDesc: 'Dùng để tìm kiếm và phân loại',
    descPlaceholder: 'Vui lòng nhập mô tả nhãn dán',
    uploadImage: 'Tải ảnh lên',
    uploadThumbnail: 'Tải ảnh thu nhỏ lên',
    reuseStickerImage: 'Dùng lại ảnh sticker',
    reuseStickerImageTip: 'Ảnh thu nhỏ sẽ dùng trực tiếp ảnh sticker, không cần tải lên riêng',
    thumbnailOptional: 'Tùy chọn, hệ thống có thể tự động tạo',
    thumbnailUploadSuccess: 'Tải ảnh thu nhỏ lên thành công',
    selectCategoryAttr: 'Vui lòng chọn danh mục',
    completeFormInfo: 'Vui lòng điền đầy đủ thông tin bắt buộc trong biểu mẫu',
    sortOrderPlaceholder: 'Số càng nhỏ càng xếp trước',
    categoryCodePlaceholder: 'Vui lòng nhập mã danh mục (chữ hoa tiếng Anh)',
    categoryCodeDesc: 'Định danh duy nhất, khuyến nghị dùng chữ hoa tiếng Anh, ví dụ: HOT, CUTE',
    inputCategoryName: 'Vui lòng nhập tên danh mục',
    inputCategoryCode: 'Vui lòng nhập mã danh mục',
    categoryCodePatternMsg: 'Vui lòng nhập chữ hoa tiếng Anh, có thể chứa dấu gạch dưới',
    categoryCodeExists: 'Mã danh mục này đã tồn tại, vui lòng thay đổi',
    uploadCategoryIcon: 'Vui lòng tải lên biểu tượng danh mục',
    sortOrderMustNumber: 'Số thứ tự phải là số',
    categoryDescPlaceholder: 'Vui lòng nhập mô tả danh mục',
    confirmDeleteCategory: 'Xác nhận xóa danh mục này?',
    exportDeveloping: 'Chức năng xuất đang được phát triển...',
    confirmDeleteGroup: 'Bạn có chắc chắn muốn xóa nhóm này không?',
    selectGroupToDelete: 'Vui lòng chọn nhóm cần xóa',
    inputGroupName: 'Vui lòng nhập tên nhóm',
    groupNameTooLong: 'Tên nhóm không được vượt quá 50 ký tự',
    inputGroupCode: 'Vui lòng nhập mã nhóm',
    groupCodeFormatMsg: 'Mã nhóm chỉ được chứa chữ hoa tiếng Anh, chữ số và dấu gạch dưới',
    groupCodeTooLong: 'Mã nhóm không được vượt quá 50 ký tự',
    groupCodeInvalidOrExists: 'Định dạng mã nhóm không hợp lệ hoặc đã tồn tại, vui lòng kiểm tra',
    uploadGroupIcon: 'Vui lòng tải lên biểu tượng nhóm',
    sortOrderInvalid: 'Vui lòng nhập số thứ tự hợp lệ (số lớn hơn hoặc bằng 0)',
    selectStatusEnableDisable: 'Vui lòng chọn trạng thái (Bật/Tắt)',
    codeCheckErrorTips: '⚠️ Xác thực mã thất bại, vui lòng thử lại sau',
    editFailed: 'Chỉnh sửa thất bại',
    operationFailedRetry: 'Thao tác thất bại, vui lòng thử lại',
    apiException: 'Lỗi hệ thống',
    selectStickerType: 'Vui lòng chọn loại nhãn dán'
  },
  filter: {
    filterName: 'Tên bộ lọc',
    addFilter: '+ Thêm bộ lọc',
    addFilterTitle: 'Thêm bộ lọc',
    editFilterTitle: 'Sửa bộ lọc',
    filterPreview: 'Xem trước bộ lọc',
    filterOriginalImage: 'Ảnh gốc của bộ lọc',
    filterResourceFile: 'Tài nguyên bộ lọc',
    belongCompany: 'Cửa hàng',
    allMerchants: 'Tất cả cửa hàng',
    type: 'Loại',
    builtIn: 'Tích hợp',
    nonBuiltIn: 'Không tích hợp',
    appliedMachines: 'Số máy đã áp dụng',
    defaultSort: 'Thứ tự',
    serialNo: 'STT',
    batchCopy: 'Sao chép hàng loạt',
    copy: 'Sao chép',
    tip: 'Thông báo',
    deletePrompt: 'Xóa bộ lọc này sẽ khiến máy không thể sử dụng bộ lọc này. Bạn có chắc chắn muốn xóa?',
    editFilterSuccess: 'Sửa bộ lọc thành công',
    loadCompanyFailed: 'Tải danh sách cửa hàng thất bại',
    copyFilterSuccess: 'Sao chép bộ lọc thành công',
    copyFilterFailed: 'Sao chép bộ lọc thất bại',
    batchCopySuccess: 'Sao chép hàng loạt bộ lọc thành công',
    batchCopyFailed: 'Sao chép hàng loạt bộ lọc thất bại',
    selectFilterFirst: 'Vui lòng chọn bộ lọc cần sao chép trước',
    copyToMerchantTitle: 'Sao chép bộ lọc cho cửa hàng',
    batchCopyTitle: 'Sao chép hàng loạt bộ lọc cho cửa hàng',
    originalFilterName: 'Tên bộ lọc gốc',
    newFilterName: 'Tên bộ lọc mới',
    inputNewFilterName: 'Vui lòng nhập tên bộ lọc mới',
    targetMerchant: 'Cửa hàng đích',
    selectCompany: 'Vui lòng chọn cửa hàng',
    selectedFilters: 'Bộ lọc đã chọn',
    nameSuffix: 'Hậu tố tên chung',
    inputNameSuffix: 'Vui lòng nhập hậu tố tên chung',
    nameSuffixTip: 'Tên bộ lọc mới = tên bộ lọc gốc + hậu tố này',
    inputFilterName: 'Vui lòng nhập tên bộ lọc',
    inputName: 'Vui lòng nhập tên',
    selectTypeMsg: 'Vui lòng chọn loại',
    inputDefaultSort: 'Vui lòng nhập thứ tự',
    colorMatrix: 'Ma trận màu',
    whitening: 'Làm trắng',
    smoothing: 'Mịn da',
    bigEye: 'Mắt to',
    thinFace: 'Mặt V',
    smallFace: 'Mặt nhỏ',
    forehead: 'Trán',
    cheekbone: 'Xương gò má',
    nose: 'Mũi',
    mouth: 'Miệng',
    chin: 'Cằm',
    intensity: 'Cường độ bộ lọc',
    sampleFullColor: 'Mẫu màu đầy đủ:',
    colorModeExample: 'Ảnh mẫu chế độ màu',
    pngFilterExample: 'Ảnh mẫu PNG gốc của bộ lọc',
    anyFormatMax10M: 'Mọi định dạng, không quá 10MB',
    colorModeNormal: 'Chế độ màu - Thường:',
    colorModePressed: 'Chế độ màu - Nhấn:',
    reuseAllSampleColor: 'Dùng lại Mẫu màu đầy đủ cho tất cả',
    addUploadImage: 'Thêm và tải ảnh lên',
    uploadFile: 'Tải tệp lên',
    reupload: 'Tải lại',
    submit: 'Gửi',
    btnNormalRequired: 'Ảnh chế độ màu - Thường không được để trống!',
    imageUrlRequired: 'Ảnh mẫu màu đầy đủ không được để trống!',
    filterPngRequired: 'Ảnh gốc của bộ lọc không được để trống!',
    btnSelectedRequired: 'Ảnh chế độ màu - Nhấn không được để trống!',
    exceed10M: 'Vượt quá giới hạn 10MB, không được phép tải lên~',
    uploadFailed: 'Tải lên thất bại'
  },
  goods: {
    productName: 'Tên sản phẩm',
    newProductName: 'Tên sản phẩm mới',
    productCode: 'Mã sản phẩm',
    preview: 'Xem trước',
    width: 'Chiều rộng',
    height: 'Chiều cao',
    imageCount: 'Số ảnh chụp',
    frameTop: 'Viền trên khung',
    frameBottom: 'Viền dưới khung',
    frameLeft: 'Viền trái khung',
    frameRight: 'Viền phải khung',
    frameCount: 'Số khung',
    printMode: 'Chế độ in',
    orientation: 'Hướng',
    price: 'Giá',
    companyPrice: 'Định giá',
    increasePrice: 'In thêm',
    defaultIncreasePrice: 'Giá in thêm',
    companyIncreasePrice: 'Định giá in thêm',
    type: 'Loại',
    deviceCount: 'Số thiết bị',
    operation: 'Thao tác',
    confirmDelete: 'Sau khi xóa, máy sẽ không thể chọn sản phẩm này. Bạn có chắc chắn muốn xóa không?',
    view: 'Xem',
    edit: 'Chỉnh sửa',
    delete: 'Xóa',
    search: 'Tìm kiếm',
    addProduct: '+ Thêm sản phẩm',
    pleaseInputContent: 'Vui lòng nhập nội dung tìm kiếm',
    sequenceNumber: 'STT',
    printingMode: 'Chế độ in',
    oneCopyInDuplicate: 'Một bản sao',
    inDuplicate: 'Nhân bản',
    vertical: 'Dọc',
    horizontal: 'Ngang',
    riceConfirmation: 'Vui lòng nhập giá đúng! Chỉ có thể lớn hơn hoặc bằng 0.01!',
    cannotEditBuiltIn: 'Sản phẩm tích hợp không thể chỉnh sửa. Chỉ supperAdmin mới có thể chỉnh sửa',
    cannotDeleteBuiltIn: 'Sản phẩm tích hợp không thể xóa. Chỉ supperAdmin mới có thể xóa',
    copy: 'Sao chép',
    copyProduct: 'Sao chép sản phẩm',
    originalProductName: 'Tên sản phẩm gốc',
    inputProductName: 'Vui lòng nhập tên sản phẩm mới',
    selectCompany: 'Vui lòng chọn cửa hàng',
    copySuccess: 'Sao chép sản phẩm thành công',
    frameManage: 'Quản lý khung ảnh',
    orderNum: 'Thứ tự',
    belongCategory: 'Danh mục',
    belongCompany: 'Cửa hàng',
    subCategory: 'Danh mục phụ',
    groupName: 'Tên nhóm'
  },
  order: {
    orderManagement: 'Quản lý đơn hàng',
    orderList: 'Danh sách đơn hàng',
    all: 'Tất cả',
    paid: 'Đã thanh toán',
    completed: 'Hoàn thành',
    unpaid: 'Chưa thanh toán',
    refunded: 'Đã hoàn tiền',
    timeout: 'Hết thời gian',
    canceled: 'Đã hủy',
    paying: 'Đang thanh toán',
    unclose: 'Chưa đóng',
    closed: 'Đã đóng',
    toBeReversed: 'Chờ đảo ngược',
    reversed: 'Đã đảo ngược',
    evaluated: 'Đã đánh giá',
    exception: 'Ngoại lệ',
    unknown: 'Không xác định',
    payFail: 'Thanh toán thất bại',
    notRefund: 'N/A',
    applyRefund: 'Yêu cầu hoàn tiền',
    refundInProgress: 'Đang hoàn tiền',
    agreeRefund: 'Đồng ý hoàn tiền',
    refuseRefund: 'Từ chối hoàn tiền',
    refundedStatus: 'Đã hoàn tiền',
    refundFail: 'Hoàn tiền thất bại',
    cancelRefund: 'Hủy hoàn tiền',
    photo: 'Chụp ảnh',
    print: 'In',
    remotePrint: 'In từ xa',
    viewRemotePhotos: 'Xem ảnh',
    remotePrintPhotos: 'Ảnh in từ xa',
    uploadPhotos: 'Ảnh đã tải lên',
    uploadPrint: 'Tải lên & In',
    noPhotos: 'Không có ảnh',
    orderNumber: 'Số đơn hàng',
    merchant: 'Cửa hàng',
    deviceNumber: 'Số thiết bị',
    payMode: 'Phương thức thanh toán',
    orderType: 'Loại đơn hàng',
    paymentStatus: 'Trạng thái thanh toán',
    totalPrice: 'Tổng giá',
    createTime: 'Thời gian tạo',
    payTime: 'Thời gian thanh toán',
    quantity: 'Số lượng',
    unitPrice: 'Đơn giá',
    discountAmount: 'Số tiền giảm giá',
    refundStatus: 'Trạng thái hoàn tiền',
    refundReason: 'Ghi chú đơn hàng',
    operation: 'Thao tác',
    export: 'Xuất',
    orderCount: 'Số đơn hàng',
    searchPlaceholder: 'Vui lòng nhập nội dung tìm kiếm',
    agree: 'Đồng ý hoàn tiền',
    refuse: 'Từ chối hoàn tiền',
    refund: 'Hoàn tiền',
    viewPhoto: 'Xem ảnh',
    gifImage: 'Ảnh GIF động',
    confirmAgreeRefund: 'Bạn có chắc chắn đồng ý yêu cầu hoàn tiền cho đơn hàng này?',
    agreeRefundContent: 'Sau khi bạn nhấp OK, đơn hàng này sẽ được hoàn tiền.',
    agreeRefundSuccess: 'Phê duyệt hoàn tiền đơn hàng thành công',
    confirmRefuseRefund: 'Bạn có chắc chắn từ chối yêu cầu hoàn tiền cho đơn hàng này?',
    refuseRefundContent: 'Sau khi bạn nhấp OK, đơn hàng này sẽ bị từ chối hoàn tiền.',
    refuseRefundSuccess: 'Từ chối hoàn tiền đơn hàng thành công',
    deviceName: 'Tên thiết bị',
    viewPhotos: 'Chi tiết ảnh',
    photoDetail: 'Chi tiết ảnh',
    compositePhotos: 'Ảnh tổng hợp',
    originalPhotos: 'Ảnh gốc',
    noCompositePhotos: 'Không có ảnh tổng hợp',
    noOriginalPhotos: 'Không có ảnh gốc',
    frameId: 'ID khung ảnh',
    copyOrderCode: 'Sao chép mã đơn hàng',
    allMerchants: 'Tất cả thương nhân',
    allDevices: 'Tất cả thiết bị',
    allPayModes: 'Tất cả phương thức thanh toán',
    payWeixin: 'WeChat',
    payAlipay: 'Alipay',
    payShouqianba: 'Shouqianba',
    payDougong: 'Dougong',
    payYunguanjia: 'Cloud Manager',
    payLeyaoyao: 'Leyaoyao',
    payCoins: 'Xu',
    payFree: 'Miễn phí',
    payCoupon: 'Mã đổi thưởng',
    payDai: 'Mã thông báo',
    payCoin: 'Trả bằng xu',
    payCash: 'Tiền mặt',
    payCard: 'Thẻ',
    copySuccess: 'Sao chép thành công',
    copyFail: 'Sao chép thất bại'
  },
  coupon: {
    all: 'Tất cả',
    notActivated: 'Chưa kích hoạt',
    activated: 'Đã kích hoạt',
    used: 'Đã sử dụng',
    cancelled: 'Đã hủy',
    searchPlaceholder: 'Vui lòng nhập mã phiếu/tên cửa hàng/tên thiết bị',
    export: 'Xuất',
    generateCoupon: 'Tạo phiếu giảm giá',
    qrCode: 'Mã QR',
    noQrCode: 'Không có',
    clickToPreview: 'Nhấp để xem trước',
    couponQrCode: 'Mã QR phiếu giảm giá',
    clickToDownload: 'Nhấp vào hình ảnh để tải xuống',
    confirmCouponInfo: 'Vui lòng xác nhận thông tin phiếu',
    merchantName: 'Tên cửa hàng',
    selectMerchant: 'Vui lòng chọn cửa hàng',
    deviceObject: 'Thiết bị',
    selectDeviceFirst: 'Vui lòng chọn thiết bị trước',
    couponQuantity: 'Số lượng phiếu',
    inputCouponQuantity: 'Vui lòng nhập số lượng phiếu',
    activateCoupon: 'Kích hoạt phiếu',
    yes: 'Có',
    no: 'Không',
    activate: 'Kích hoạt',
    cancel: 'Hủy',
    couponId: 'Mã phiếu',
    merchant: 'Cửa hàng',
    deviceName: 'Tên thiết bị',
    couponCode: 'Mã phiếu',
    status: 'Trạng thái',
    createTime: 'Thời gian tạo',
    operation: 'Thao tác',
    activateSuccess: 'Kích hoạt thành công!',
    activateFailed: 'Kích hoạt thất bại!',
    cancelSuccess: 'Hủy thành công!',
    cancelFailed: 'Hủy thất bại!',
    generateSuccess: 'Tạo thành công!',
    generateFailed: 'Tạo thất bại!',
    generating: 'Đang tạo phiếu giảm giá, vui lòng đợi...',
    maxCouponLimit: 'Không thể tạo hơn 500 phiếu cùng lúc!',
    generateTip: 'Mỗi lần có thể tạo tối đa 500 phiếu giảm giá. Nếu cần nhiều hơn, vui lòng tạo theo đợt. Mỗi máy có thể tạo tối đa 2000 phiếu giảm giá mỗi tháng.',
    selectMerchantFirst: 'Vui lòng chọn cửa hàng trước!',
    downloadSuccess: 'Tải xuống thành công!',
    superCoupon: 'Phiếu quà tặng đặc biệt',
    setSuperCoupon: 'Đặt làm phiếu đặc biệt',
    setSuperCouponConfirm: 'Bạn có chắc chắn muốn đặt phiếu này thành phiếu quà tặng đặc biệt không? Phiếu đặc biệt hiện có trên thiết bị này sẽ tự động bị hạ cấp thành phiếu thường.',
    setSuperCouponSuccess: 'Đặt phiếu đặc biệt thành công!',
    setSuperCouponFailed: 'Đặt phiếu đặc biệt thất bại!',
    delete: 'Xóa',
    batchDelete: 'Xóa hàng loạt',
    deleteConfirm: 'Bạn có chắc chắn muốn xóa phiếu này? Không thể khôi phục sau khi xóa!',
    batchDeleteConfirm: 'Bạn có chắc chắn muốn xóa {count} phiếu đã chọn? Không thể khôi phục sau khi xóa!',
    deleteSuccess: 'Xóa thành công!',
    deleteFailed: 'Xóa thất bại!',
    selectDeleteFirst: 'Vui lòng chọn phiếu cần xóa trước!'
  },
  dashboard: {
    date: 'Ngày',
    flow: 'Lưu lượng khách',
    companyCount: 'Số cửa hàng mới',
    deviceCount: 'Số thiết bị mới',
    photoCount: 'Số đơn chụp ảnh',
    printCount: 'Số đơn in',
    amount: 'Tổng thu nhập nền tảng',
    justSumAmount: 'Chia sẻ nền tảng',
    companySumAmount: 'Chia sẻ cửa hàng',
    lineCount: 'Số thiết bị trực tuyến',
    companyName: 'Tên cửa hàng',
    deviceCode: 'Mã thiết bị',
    activeCode: 'Mã thiết bị',
    deviceName: 'Tên thiết bị',
    photo: 'Số đơn chụp ảnh',
    print: 'Số đơn in',
    totalPrice: 'Tổng thu nhập nền tảng',
    timeCycle: 'Thời gian',
    defaultTimeFilter: 'Bộ lọc thời gian mặc định (tháng)',
    month: 'Tháng',
    week: 'Tuần',
    day: 'Ngày',
    search: 'Tìm kiếm',
    export: 'Xuất',
    refund: 'Hoàn tiền',
    confirmRefund: 'Bạn có chắc chắn yêu cầu hoàn tiền cho đơn hàng này?',
    refundContent: 'Sau khi bạn nhấp OK, đơn hàng này sẽ khởi tạo yêu cầu hoàn tiền.',
    refundSuccess: 'Yêu cầu hoàn tiền đơn hàng thành công',
    confirmAgreeRefund: 'Bạn có chắc chắn đồng ý yêu cầu hoàn tiền cho đơn hàng này?',
    agreeRefundContent: 'Sau khi bạn nhấp OK, đơn hàng này sẽ được hoàn tiền.',
    agreeRefundSuccess: 'Phê duyệt hoàn tiền đơn hàng thành công',
    confirmRefuseRefund: 'Bạn có chắc chắn từ chối yêu cầu hoàn tiền cho đơn hàng này?',
    refuseRefundContent: 'Sau khi bạn nhấp OK, đơn hàng này sẽ bị từ chối hoàn tiền.',
    refuseRefundSuccess: 'Từ chối hoàn tiền đơn hàng thành công',
    timeRangeRequired: 'Phạm vi thời gian không thể trống'
  },
  uiGroup: {
    uiGroupManage: 'Quản lý nhóm UI',
    newUIGroup: 'Nhóm UI mới',
    searchUIName: 'Tìm kiếm tên nhóm UI...',
    resourceType: 'Loại tài nguyên',
    adminDefine: 'Quản trị viên xác định',
    merchantDefine: 'Cửa hàng xác định',
    uiName: 'Tên UI',
    subPageCount: 'Số trang con',
    downloadPackage: 'Tải gói',
    onlyOneInCategoryCannotDelete: 'Chỉ còn một nhóm UI trong danh mục này (ngôn ngữ + sản phẩm), không thể xóa',
    remark: 'Ghi chú',
    createTime: 'Thời gian tạo',
    pageManage: 'Quản lý trang',
    copy: 'Sao chép',
    copyPrompt: 'Bạn có chắc chắn muốn sao chép nhóm UI này?',
    copySuccess: 'Sao chép thành công',
    copyFail: 'Sao chép thất bại',
    copyUIGroup: 'Sao chép nhóm UI',
    originalUIName: 'Tên nhóm UI gốc',
    newUIName: 'Tên nhóm UI mới',
    inputNewUIName: 'Vui lòng nhập tên nhóm UI mới',
    selectCompany: 'Vui lòng chọn công ty',
    companyName: 'Tên công ty',
    addUIGroup: 'Nhóm UI mới',
    deletePrompt: 'Bạn có chắc chắn muốn xóa nhóm UI này?',
    deleteSuccess: 'Xóa thành công',
    editUIGroup: 'Chỉnh sửa nhóm UI',
    editSuccess: 'Chỉnh sửa thành công',
    addSuccess: 'Thêm nhóm UI thành công',
    addFail: 'Thêm nhóm UI thất bại',
    newPage: 'Trang mới',
    editPage: 'Chỉnh sửa trang',
    addPage: 'Thêm trang',
    pageName: 'Tên trang',
    pageKey: 'Khóa trang',
    pageOrder: 'Thứ tự trang',
    elementCount: 'Số phần tử',
    elementManage: 'Quản lý phần tử',
    pleaseInputPageName: 'Vui lòng nhập tên trang',
    pleaseInputPageKey: 'Vui lòng nhập khóa trang',
    pleaseInputPageOrder: 'Vui lòng nhập thứ tự trang',
    deletePagePrompt: 'Bạn có chắc chắn muốn xóa trang này? Không thể khôi phục sau khi xóa!',
    addPageSuccess: 'Thêm trang thành công',
    addPageFail: 'Thêm trang thất bại',
    editPageSuccess: 'Chỉnh sửa trang thành công',
    editPageFail: 'Chỉnh sửa trang thất bại',
    deletePageSuccess: 'Xóa trang thành công',
    deletePageFail: 'Xóa trang thất bại',
    pageKeyExists: 'Khóa trang đã tồn tại, vui lòng thay đổi',
    productType: 'Loại sản phẩm',
    elementName: 'Tên phần tử',
    elementType: 'Loại phần tử',
    allElement: 'Tất cả phần tử',
    editElement: 'Chỉnh sửa phần tử',
    addElement: 'Thêm phần tử',
    elementValue: 'Giá trị phần tử',
    elementValueMsg: 'Vui lòng nhập giá trị phần tử',
    elementKey: 'Khóa phần tử',
    elementKeyMsg: 'Vui lòng nhập khóa phần tử',
    elementKeyPlaceholder: 'Khóa phần tử không được trùng lặp trong cùng một trang, khuyến nghị sử dụng chữ cái và gạch dưới',
    elementNameMsg: 'Vui lòng nhập tên phần tử',
    elementTypeMsg: 'Vui lòng chọn loại phần tử',
    elementKeyError: 'Khóa phần tử đã tồn tại trên trang hiện tại, vui lòng thay đổi',
    elemnetDeleteTips: 'Bạn có chắc chắn muốn xóa phần tử này?',
    batchEditElement: 'Chỉnh sửa phần tử hàng loạt',
    horizontalLayout: 'Bố cục ngang',
    verticalLayout: 'Bố cục dọc',
    loadingElementList: 'Đang tải danh sách phần tử...',
    allResourceType: 'Tất cả loại tài nguyên',
    pleaseInputUIName: 'Vui lòng nhập tên nhóm UI',
    pleaseSelectResourceType: 'Vui lòng chọn loại tài nguyên',
    previewImage: 'Ảnh xem trước',
    reupload: 'Tải lên lại',
    uploadPreviewImage: 'Tải lên ảnh xem trước',
    languageType: 'Ngôn ngữ',
    selectLanguageType: 'Vui lòng chọn ngôn ngữ',
    pageSize: 'Kích thước trang',
    pixelWH: 'Điểm ảnh (R×C)',
    belongCompany: 'Thương nhân',
    cancelDefaultConfirm: 'Bạn có chắc chắn muốn hủy trạng thái mặc định của nhóm UI này không?',
    setDefaultConfirm: 'Bạn có chắc chắn muốn đặt nhóm UI này làm mặc định không?',
    operateSuccess: 'Thao tác thành công!',
    operateFail: 'Thao tác thất bại',
    onlyJpgPng: 'Chỉ có thể tải lên ảnh định dạng JPG và PNG!',
    exceed4M: 'Kích thước ảnh không được vượt quá 4MB!',
    uploadSuccess: 'Tải lên thành công',
    uploadSuccessNoUrl: 'Tải lên thành công nhưng không thể lấy địa chỉ ảnh',
    inputImageUrlPlaceholder: 'Hoặc nhập trực tiếp địa chỉ ảnh (http/https)',
    useImageUrl: 'Dùng địa chỉ này',
    invalidImageUrl: 'Vui lòng nhập địa chỉ ảnh hợp lệ (bắt đầu bằng http:// hoặc https://)',
    imageUrlApplied: 'Đã áp dụng địa chỉ ảnh',
    pasteTip: 'Mẹo: Sau khi sao chép ảnh hoặc chụp màn hình, nhấn Ctrl+V/Cmd+V để dán và tải lên',
    pasteUploadSuccess: 'Tải lên ảnh dán thành công',
    langZhCN: 'Tiếng Trung giản thể',
    langEn: 'Tiếng Anh',
    langFr: 'Tiếng Pháp',
    langKo: 'Tiếng Hàn',
    langZhTW: 'Tiếng Trung phồn thể',
    langVi: 'Tiếng Việt',
    langAr: 'Tiếng Ả Rập',
    langBih: 'Tiếng Bosnia',
    langTh: 'Tiếng Thái',
    langDe: 'Tiếng Đức',
    langEs: 'Tiếng Tây Ban Nha'
  },
  deviceSetup: {
    title: 'Cài đặt thiết bị',
    basicInfo: 'Thông tin cơ bản',
    machineModelSN: 'Mã máy [SN]',
    inputMachineSN: 'Vui lòng nhập mã SN',
    machineName: 'Tên máy',
    inputMachineName: 'Vui lòng nhập tên máy',
    machineCode: 'Mã thiết bị',
    inputMachineCode: 'Vui lòng nhập mã thiết bị',
    machineAddress: 'Địa chỉ máy',
    inputMachineAddress: 'Vui lòng nhập địa chỉ',
    activationCode: 'Mã kích hoạt',
    h5Url: 'URL trang H5',
    parseUrl: 'Phân tích URL',
    urlEditorTitle: 'Quản lý tham số URL H5',
    urlBase: 'URL gốc',
    urlParams: 'Tham số URL',
    paramName: 'Tên tham số',
    paramValue: 'Giá trị tham số',
    addParam: 'Thêm tham số',
    noParams: 'Chưa có tham số. Nhấp "Thêm tham số" để thêm',
    done: 'Hoàn tất',
    pasteTip: 'Mẹo: Sau khi sao chép ảnh hoặc chụp màn hình, nhấn Ctrl+V để dán và tải lên',
    pasteUploadSuccess: 'Tải lên ảnh dán thành công',
    filterByCompany: 'Lọc theo nhà bán hàng',
    customerServicePhone: 'Số điện thoại hỗ trợ',
    photoAccessType: 'Phương thức truy cập ảnh',
    selectPhotoAccessType: 'Vui lòng chọn loại',
    paymentMode: 'Chế độ thanh toán',
    selectPaymentMode: 'Vui lòng chọn loại',
    onlinePayment: 'Thanh toán trực tuyến',
    offlineCoin: 'Xu offline',
    scanQRCode: 'Quét mã QR',
    addFriend: 'Thêm bạn bè',
    machineSettings: 'Cài đặt máy',
    uiGroupSelection: 'Chọn nhóm UI',
    selectUiGroup: 'Vui lòng chọn nhóm UI',
    uiSelection: 'Chọn UI',
    searchUiName: 'Tìm kiếm tên UI',
    viewAll: 'Tất cả',
    viewSelected: 'Đã chọn',
    builtIn: 'Tích hợp',
    notBuiltIn: 'Không tích hợp',
    productSelection: 'Chọn sản phẩm',
    searchProductName: 'Tìm kiếm tên sản phẩm',
    selectAll: 'Chọn tất cả',
    frameSelection: 'Chọn khung',
    selectProductFirst: 'Vui lòng chọn sản phẩm trước',
    searchFrameName: 'Tìm kiếm tên khung',
    noProductSelected: 'Vui lòng chọn ít nhất một sản phẩm trước',
    noFrameData: 'Không có dữ liệu khung cho sản phẩm này',
    filterSelection: 'Chọn bộ lọc',
    searchFilterName: 'Tìm kiếm tên bộ lọc',
    stickerGroup: 'Nhóm nhãn dán',
    searchGroupName: 'Tìm kiếm tên nhóm',
    noStickerGroupData: 'Không có dữ liệu nhóm nhãn dán',
    stickersCount: '{count} nhãn dán',
    parameterSettings: 'Cài đặt tham số',
    photoTime: 'Thời gian chụp',
    seconds: 'giây',
    inputPhotoTime: 'Vui lòng nhập thời gian chụp',
    intervalTime: 'Thời gian间隔',
    inputIntervalTime: 'Vui lòng nhập khoảng thời gian',
    paperCount: 'Số giấy',
    sheets: 'tờ',
    inputPaperCount: 'Vui lòng nhập số giấy',
    paperCountRequired: 'Bắt buộc nhập số giấy',
    cancel: 'Hủy',
    save: 'Lưu',
    selectAtLeastOneProduct: 'Vui lòng chọn ít nhất một sản phẩm',
    selectAtLeastOneFilter: 'Vui lòng chọn ít nhất một bộ lọc',
    paperCountMinLimit: 'Số giấy không được thấp hơn 50',
    serverConnectionError: 'Lỗi kết nối máy chủ, vui lòng thử lại sau!',
    deviceThumbnail: 'Ảnh thu nhỏ thiết bị',
    modify: 'Sửa',
    upload: 'Tải lên',
    remoteDesktopInfo: 'Thông tin điều khiển từ xa',
    remoteDesktopPlaceholder: 'Vui lòng nhập thông tin điều khiển từ xa (mã từ xa)',
    format: 'Định dạng',
    belongCategory: 'Danh mục',
    selectBelongCategory: 'Vui lòng chọn danh mục',
    onlyJpgPng: 'Chỉ có thể tải lên ảnh định dạng JPG và PNG~',
    exceed4M: 'Vượt quá giới hạn 4M, không được phép tải lên~',
    thumbnailUploadFailed: 'Tải lên ảnh thu nhỏ thất bại',
    jsonFormatErrorFormat: 'Định dạng JSON không hợp lệ, không thể định dạng, vui lòng kiểm tra và thử lại',
    jsonFormatError: 'Định dạng JSON không hợp lệ, vui lòng kiểm tra và thử lại',
    showName: 'Tên hiển thị thiết bị (Quét mã QR để tải xuống tiêu đề trang ảnh điện tử)',
    showNamePlaceholder: 'Hiển thị làm tiêu đề trên trang tải ảnh điện tử'
  },
  personal: {
    oldPassword: 'Mật khẩu cũ',
    inputOldPassword: 'Vui lòng nhập mật khẩu cũ',
    strength: 'Độ mạnh: ',
    passwordTip: 'Vui lòng nhập ít nhất 6 ký tự. Không dùng mật khẩu dễ đoán.',
    newPassword: 'Mật khẩu mới',
    passwordPlaceholder: 'Ít nhất 6 ký tự, phân biệt hoa thường',
    confirmPassword: 'Xác nhận lại',
    confirmPasswordPlaceholder: 'Xác nhận mật khẩu',
    levelLow: 'Yếu',
    levelMedium: 'Trung bình',
    levelStrong: 'Mạnh',
    minSixChars: 'Vui lòng nhập mật khẩu ít nhất 6 ký tự',
    strengthNotEnough: 'Độ mạnh mật khẩu không đủ',
    inputPassword: 'Vui lòng nhập mật khẩu',
    passwordNotMatch: 'Hai mật khẩu không khớp',
    oldPasswordIncorrect: 'Mật khẩu cũ không đúng',
    editProfile: 'Chỉnh sửa hồ sơ',
    updateAvatar: 'Đổi ảnh đại diện',
    avatarAlt: 'Ảnh đại diện',
    avatarUpdateSuccess: 'Cập nhật ảnh đại diện thành công',
    email: 'Email',
    mobile: 'Di động',
    dept: 'Phòng ban',
    gender: 'Giới tính',
    description: 'Mô tả',
    inputEmail: 'Vui lòng nhập email',
    inputMobile: 'Vui lòng nhập số di động',
    emailInvalid: 'Vui lòng nhập email hợp lệ',
    emailMax: 'Độ dài không vượt quá 50 ký tự',
    mobileInvalid: 'Vui lòng nhập số di động hợp lệ',
    selectGender: 'Vui lòng chọn giới tính',
    descMax: 'Độ dài không vượt quá 100 ký tự',
    submit: 'Gửi',
    selectAvatar: 'Chọn ảnh đại diện',
    clickToSelect: 'Nhấp để chọn',
    updatingWarning: 'Đang đổi ảnh đại diện, vui lòng không nhấp liên tục',
    updateAvatarFailed: 'Cập nhật ảnh đại diện thất bại',
    tabHthz: 'Houtian Huazi',
    tabAl: 'Loạt Ali',
    tabLm: 'LianMeng'
  },
  userInfo: {
    title: 'Thông tin người dùng',
    account: 'Tài khoản: ',
    role: 'Vai trò: ',
    noRole: 'Chưa có vai trò',
    male: 'Nam',
    female: 'Nữ',
    confidential: 'Bảo mật',
    department: 'Phòng ban: ',
    noDepartment: 'Chưa có phòng ban',
    gender: 'Giới tính: ',
    phone: 'Điện thoại: ',
    noPhone: 'Chưa liên kết điện thoại',
    email: 'Email: ',
    noEmail: 'Chưa liên kết email',
    status: 'Trạng thái: ',
    locked: 'Khóa',
    valid: 'Hiệu lực',
    createTime: 'Tạo lúc: ',
    lastLogin: 'Đăng nhập gần nhất: ',
    description: 'Mô tả: '
  },
  remotePrint: {
    loading: 'Đang tải...',
    expired: 'Đã hết hạn',
    expiredDesc: 'Hồ sơ tải lên này đã hết hạn. Vui lòng quay lại thiết bị và thử lại.',
    completed: 'Hoàn thành',
    completedDesc: 'Ảnh đã được gửi thành công. Vui lòng chờ bên thiết bị để in.',
    submitted: 'Đã gửi',
    submittedDesc: 'Ảnh đã được gửi đến thiết bị. Vui lòng hoàn tất các thao tác tiếp theo trên máy.',
    orderInfo: 'Thông tin đơn hàng',
    recordCode: 'Mã hồ sơ',
    orderCode: 'Mã đơn hàng',
    product: 'Sản phẩm',
    price: 'Giá',
    expireTime: 'Hết hạn lúc',
    photos: 'Ảnh',
    addPhoto: 'Thêm ảnh',
    tipFormat: 'Chỉ hỗ trợ ảnh JPG/PNG',
    tipSize: 'Mỗi ảnh không quá 3MB',
    tipExpire: 'Hồ sơ có hiệu lực 5 phút, vui lòng tải lên nhanh',
    submit: 'Tải lên & In',
    submitting: 'Đang gửi...',
    noRecordCode: 'Thiếu mã hồ sơ. Vui lòng quét mã QR.',
    loadFailed: 'Tải thất bại. Vui lòng thử lại.',
    invalidFormat: 'Chỉ hỗ trợ JPG/PNG',
    photoLimit: 'Chỉ có thể tải lên tối đa {count} ảnh',
    fileTooLarge: 'Kích thước tệp không được vượt quá 10MB',
    uploadFailed: 'Tải lên thất bại. Vui lòng thử lại.',
    noPhotoUploaded: 'Vui lòng tải lên ít nhất một ảnh',
    submitFailed: 'Gửi thất bại. Vui lòng thử lại.'
  }
}



// WEBPACK FOOTER //
// ./src/lang/vi-VN.js